//css import
import '../../scss/pages/home.scss';
import 'swiper/css/bundle';
//js import
import Swiper from 'swiper/bundle';
import { gsap } from "gsap";
import { Modal } from 'bootstrap';


//declaration variable
let tabMobileLinks=document.querySelectorAll('.navbar-custom__tab-mobile-link');
let tabSectionLinks=document.querySelectorAll('.tab-section-link');
let bannerSwiperContainer = document.querySelector(
    ".banner__slider"
);

for (const tabMobileLink of tabMobileLinks) {
    tabMobileLink.addEventListener('click', function onClick() {
        //console.log('test');
        let tabID=tabMobileLink.dataset.id
        let tabBG=tabMobileLink.dataset.bg
        removeClassOnTabSectionLink()
        let tabIds=document.querySelectorAll('.tab-'+tabID);

        tabIds.forEach(tabId => {
            tabId.classList.add('active');
        });
    });
}

for (const tabSectionLink of tabSectionLinks) {
    tabSectionLink.addEventListener('click', function onClick() {
        let tabID=tabSectionLink.dataset.id
        let tabBG=tabSectionLink.dataset.bg
        removeClassOnNavTabLink()
        let tabIds=document.querySelectorAll('.tab-'+tabID);
        let tabMobileID=document.querySelector('.tab-mobile-'+tabID);
        tabIds.forEach(tabId => {
            tabId.classList.add('active');
            tabMobileID.style.background=tabBG
        });
    });
}

function removeClassOnTabSectionLink(){
    tabSectionLinks.forEach(tabSectionLink => {
        tabSectionLink.classList.remove('active');
    });
}

function removeClassOnNavTabLink(){
    tabMobileLinks.forEach(tabMobileLink => {
        tabMobileLink.classList.remove('active');
        tabMobileLink.style.background='#ffffff';
    });
}

let bannerSlider = new Swiper(".banner__slider", {
    spaceBetween: 0,
    slidesPerView:1,
    effect: "fade",
    preventInteractionOnTransition: true,
    loop:true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: ".banner__next",
        prevEl: ".banner__prev",
    },
    pagination: {
        el: ".banner__pagination",
        clickable: true,
    },
});

bannerSwiperContainer.addEventListener("mouseenter", (e) => {
    bannerSlider.autoplay.stop();
});
bannerSwiperContainer.addEventListener("mouseleave", (e) => {
    bannerSlider.autoplay.start();
});

bannerSlider.on('slideChangeTransitionStart', function() {
    gsap.to(
        ".banner__image",
        { duration:15, scale:1},
    );
    gsap.to(
        ".banner__title",
        { autoAlpha: 0, y: -50, opacity:0, duration: 0 },
    );

    gsap.to(
        ".banner__btn",
        { autoAlpha: 0, y: 50, opacity:0, duration: 0 },
    );
})

bannerSlider.on("slideChangeTransitionEnd", function () {
    gsap.to(
        ".banner__image",
        { duration:15, scale:1.2}
    );
    gsap.to(
        ".banner__title",
        { autoAlpha: 1, duration: 0.7, y: 0, opacity:1, delay: 1.5 }
    );

    gsap.to(
        ".banner__btn",
        { autoAlpha: 1, duration: 0.7, y: 0, opacity:1, delay: 1.5 }
    );
});

let testimonialSlider = new Swiper('.testimonial__slider', {
    speed:1000,
    spaceBetween: 16,
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    freeMode: true,
    navigation: {
        prevEl: ".testimonial__prev",
        nextEl: ".testimonial__next",
    },
    pagination: {
        el: ".testimonial__pagination",
        clickable:true
    },
    breakpoints: {
        320: {
            centeredSlides: false,
            slidesPerView: 2
        },
        768:{
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
        },
        992:{
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
        },
        1024:{
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
        },
        1440:{
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false,
        },
        1600:{
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false,
        },
        1920:{
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false,
        }
    }
});


// const readMoreParagraphs = document.querySelectorAll('.teamTestiContent');
// new Readmore( readMoreParagraphs, {
//     speed: 200,
//     collapsedHeight: 240,
//     lessLink: '<a href="#" class="read-more" id="read-more-link">Read less</a>',
//     moreLink: '<a href="#" class="read-more" id="read-more-link">Read more...</a>',
// });


$('.card-product__readmore').readmore({
    speed: 200, //Açılma Hızı
    collapsedHeight: 100, // 100px sonra yazının kesileceğini belirtir.
    moreLink: '<button class="btn-show-more" href="#">Show more</button>', // açma linki yazısı
    lessLink: '<button class="btn-show-less" href="#">Show Less</button>', // kapatma linki yazısı
  });

// readMoreParagraphs.readmore()

const promoModal = new Modal('#promoModal')

if (promoModal) {
    setTimeout(() => {
        promoModal.show()
    }, 3000);
}